import './index.scss';
import './style/main';
import $ from 'jquery';
import img_header__logo from './images/destop/logo.png';
import img_header__logo_m from './images/mobile/logo.png';

import img_header__HAA__logo from './images/destop/haa-logo.png';
import img_header__HAA__logo_m from './images/mobile/haa-logo.png';

import img_main__title from './images/destop/tt.png';
import img_main__title_m from './images/mobile/tt.png';

import img_subtitle__title from './images/destop/subtitle-title.png';
import img_subtitle__title_m from './images/mobile/subtitle-title.png';

import img_subtitle__btn1 from './images/destop/btn-1.png';
import img_subtitle__btn1_m from './images/mobile/btn-1.png';

import img_subtitle__btn2 from './images/destop/btn-car.png';
import img_subtitle__btn2_m from './images/mobile/btn-car.png';

import img_detail__1 from './images/destop/1.png';
import img_detail__1_m from './images/mobile/1.png';

import img_detail__2 from './images/destop/2.png';
import img_detail__2_m from './images/mobile/2.png';

import img_detail__3 from './images/destop/3.png';
import img_detail__3_m from './images/mobile/3.png';

import img_detail__4 from './images/destop/4.png';
import img_detail__4_m from './images/mobile/4.png';

import img_detail__5 from './images/destop/5.png';
import img_detail__5_m from './images/mobile/5.png';

import img_detail__6 from './images/destop/6.png';
import img_detail__6_m from './images/mobile/6.png';

import img_detail__7 from './images/destop/7.png';
import img_detail__7_m from './images/mobile/7.png';

import img_detail__flow from './images/destop/flow-btn.png';
import img_detail__flow_m from './images/mobile/flow-btn.png';

import img_introduction__title1 from './images/destop/introduction__title1.png';
import img_introduction__title1_m from './images/mobile/introduction__title1.png';

import img_introduction__title2 from './images/destop/introduction__title2.png';
import img_introduction__title2_m from './images/mobile/introduction__title2.png';

import img_introduction__title3 from './images/destop/introduction__title3.png';
import img_introduction__title3_m from './images/mobile/introduction__title3.png';

import img_introduction__info__videoImg from './images/destop/pic.png';
import img_introduction__info__videoImg_m from './images/mobile/pic.png';

import img_playBtn from './images/destop/play.png';
import img_playBtn_m from './images/mobile/play.png';

import img_footer__goTop from './images/destop/btn-top.png';
import img_footer__goTop_m from './images/mobile/btn-top.png';

import img_footer__result from './images/destop/btn-result.png';
import img_footer__result_m from './images/mobile/btn-result.png';

import img_footer__addFavourite from './images/destop/btn-addFavourite.png';
import img_footer__addFavourite_m from './images/mobile/btn-addFavourite.png';

import img_detailFlowPage__close from './images/destop/btn-close.png';
import img_detailFlowPage__close_m from './images/mobile/btn-close.png';

import img_nav__btn1 from './images/destop/btn-side-1.png';

import img_nav__btn2 from './images/destop/btn-side-2.png';

// 更新圖片（Desktop || mobile）
function updateImages() {
  const screenWidth = $(window).width();
  const header__logo = $('.header__logo');
  const header__HAA__logo = $('.header__HAA__logo');
  const main__title = $('.main__title');
  const subtitle__title = $('.subtitle__title');
  const subtitle__btn1 = $('.subtitle__btn1');
  const subtitle__btn2 = $('.subtitle__btn2');
  const detail__1 = $('.detail__1');
  const detail__2 = $('.detail__2');
  const detail__3 = $('.detail__3');
  const detail__4 = $('.detail__4');
  const detail__5 = $('.detail__5');
  const detail__6 = $('.detail__6');
  const detail__7 = $('.detail__7');
  const detail__flow = $('.detail__flow');
  const introduction__title_fake = $('.introduction__title_fake');
  const introduction__title1 = $('.introduction__title1');
  const introduction__title2 = $('.introduction__title2');
  const introduction__title3 = $('.introduction__title3');
  const introduction__info__videoImg = $('.introduction__info__videoImg');
  const introduction__info__play = $('.introduction__info__play');
  const footer__goTop = $('.footer__goTop');
  const footer__reply = $('.footer__reply');
  const footer__result = $('.footer__result');
  const footer__addFavourite = $('.footer__addFavourite');
  const detailFlowPage__close = $('.detailFlowPage__close');
  const nav__btn1 = $('.img_nav__btn1');
  const nav__btn2 = $('.img_nav__btn2');

  // desktop
  if (screenWidth >= 576) {
    header__logo.attr('src', img_header__logo);
    header__HAA__logo.attr('src', img_header__HAA__logo);
    main__title.attr('src', img_main__title);
    subtitle__title.attr('src', img_subtitle__title);
    subtitle__btn1.attr('src', img_subtitle__btn1);
    subtitle__btn2.attr('src', img_subtitle__btn2);
    detail__1.attr('src', img_detail__1);
    detail__2.attr('src', img_detail__2);
    detail__3.attr('src', img_detail__3);
    detail__4.attr('src', img_detail__4);
    detail__5.attr('src', img_detail__5);
    detail__6.attr('src', img_detail__6);
    detail__7.attr('src', img_detail__7);
    detail__flow.attr('src', img_detail__flow);
    introduction__title1.attr('src', img_introduction__title1);
    introduction__title2.attr('src', img_introduction__title2);
    introduction__title3.attr('src', img_introduction__title3);
    introduction__info__videoImg.attr('src', img_introduction__info__videoImg);
    introduction__info__play.attr('src', img_playBtn);
    footer__goTop.attr('src', img_footer__goTop);
    footer__reply.attr('src', img_subtitle__btn2);
    footer__result.attr('src', img_footer__result);
    footer__addFavourite.attr('src', img_footer__addFavourite);
    detailFlowPage__close.attr('src', img_detailFlowPage__close);
    nav__btn1.attr('src', img_nav__btn1);
    nav__btn2.attr('src', img_nav__btn2);
  }
  // mobile
  else {
    header__logo.attr('src', img_header__logo_m);
    header__HAA__logo.attr('src', img_header__HAA__logo_m);
    main__title.attr('src', img_main__title_m);
    subtitle__title.attr('src', img_subtitle__title_m);
    subtitle__btn1.attr('src', img_subtitle__btn1_m);
    subtitle__btn2.attr('src', img_subtitle__btn2_m);
    detail__1.attr('src', img_detail__1_m);
    detail__2.attr('src', img_detail__2_m);
    detail__3.attr('src', img_detail__3_m);
    detail__4.attr('src', img_detail__4_m);
    detail__5.attr('src', img_detail__5_m);
    detail__6.attr('src', img_detail__6_m);
    detail__7.attr('src', img_detail__7_m);
    detail__flow.attr('src', img_detail__flow_m);
    introduction__title_fake.attr('src', img_introduction__title2_m);
    introduction__title1.attr('src', img_introduction__title1_m);
    introduction__title2.attr('src', img_introduction__title2_m);
    introduction__title3.attr('src', img_introduction__title3_m);
    introduction__info__videoImg.attr(
      'src',
      img_introduction__info__videoImg_m
    );
    introduction__info__play.attr('src', img_playBtn_m);
    footer__goTop.attr('src', img_footer__goTop_m);
    footer__reply.attr('src', img_subtitle__btn2_m);
    footer__result.attr('src', img_footer__result_m);
    footer__addFavourite.attr('src', img_footer__addFavourite_m);
    detailFlowPage__close.attr('src', img_detailFlowPage__close_m);
  }
}

// 開關/委拍流程簡介
function toggleDetailFlowPage() {
  $('main').toggle();
  $('footer').toggle();
  $('.detailFlowPage').toggle();
  $(window).scrollTop(0)
}

// 第一部影片title顯示方式
function toggleVideoTitle() {
  if ($(window).width() >= 992) return ;
  const scrollBottom = $(window).scrollTop() + $(window).height();
  const fakeVideoTitle = $('.introduction__title_fake');
  const videoTitle = $('.introduction__title3');
  const videoTitleCoordinate = videoTitle.offset();
  fakeVideoTitle.width(videoTitle.width());
  if (scrollBottom < videoTitleCoordinate.top + videoTitle.height()) {
    fakeVideoTitle.css('opacity', 1);
  } else {
    fakeVideoTitle.css('opacity', 0);
  }
}

updateImages();
toggleVideoTitle();
// 監聽 resize
$(window).resize(function (e) {
  updateImages();
  const windowWidth = $(window).width();
  const fakeVideoTitle = $('.introduction__title_fake');
  if (windowWidth >= 992) fakeVideoTitle.css('opacity', 0);
  if (windowWidth < 992) fakeVideoTitle.css('opacity', 1);
});
// 切換委拍流程簡介
$('.detail__flow').click(toggleDetailFlowPage);
$('.detailFlowPage__close').click(toggleDetailFlowPage);
// 加入我的最愛
$('.bookmarkme').click(function () {
  const triggerBookmark = $(this);

  if (window.sidebar && window.sidebar.addPanel) {
    // Firefox <23

    window.sidebar.addPanel(document.title, window.location.href, '');
  } else if (window.external && 'AddFavorite' in window.external) {
    // Internet Explorer

    window.external.AddFavorite(location.href, document.title);
  } else if (
    (window.opera && window.print) ||
    (window.sidebar && !(window.sidebar instanceof Node))
  ) {
    // Opera <15 and Firefox >23
    /**
     * For Firefox <23 and Opera <15, no need for JS to add to bookmarks
     * The only thing needed is a `title` and a `rel="sidebar"`
     * To ensure that the bookmarked URL doesn't have a complementary `#` from our trigger's href
     * we force the current URL
     */
    triggerBookmark
      .attr('rel', 'sidebar')
      .attr('title', document.title)
      .attr('href', window.location.href);
    return true;
  } else {
    // For the other browsers (mainly WebKit) we use a simple alert to inform users that they can add to bookmarks with ctrl+D/cmd+D

    alert(
      'You can add this page to your bookmarks by pressing ' +
        (navigator.userAgent.toLowerCase().indexOf('mac') != -1
          ? 'Command/Cmd'
          : 'CTRL') +
        ' + D on your keyboard.'
    );
  }
  // If you have something in the `href` of your trigger
  return false;
});
// 切換影片
$('.introduction__info__item').click(function () {
  const videoWrap = $('#video_2 .introduction__info__iframe');
  const videoSrc = $(this).data('video').replace('watch?v=', 'embed/');
  const _iframe = $('#v');
  _iframe.remove();
  $(`<iframe id="v" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen ></iframe>`)
    .attr('src', videoSrc)
    .appendTo(videoWrap);
});

//
$(window).scroll(toggleVideoTitle);

// 點擊浮動影片標題 scroll to 影片區
$('.introduction__title_fake').click(function () {
  $(window).scrollTop($('.introduction__title2').offset().top - 60);
})
$('#toVideo2').click(function () {
  $(window).scrollTop($('.introduction__title2').offset().top - 60);
})
